<script setup>
  import { ref, onBeforeMount, computed, onMounted } from "vue";
  import {
    DxDataGrid,
    DxColumn,
    // DxFilterRow,
    DxHeaderFilter,
    DxToolbar,
    DxItem,
    DxPaging,
    DxPager,
    DxSorting,
    DxScrolling,
    DxColumnChooser,
    DxStateStoring,
    DxLoadPanel,
    DxSearchPanel,
    } from 'devextreme-vue/data-grid';
    // import DxDropDownButton from "devextreme-vue/drop-down-button";
    // import { default as Button } from "devextreme-vue/button";
    import { exportDataGrid } from "devextreme/excel_exporter";
    import { exportDataGrid as exportDataGridToPdf } from "devextreme/pdf_exporter";
    import { Workbook } from "exceljs";
    import saveAs from "file-saver";
    import { jsPDF } from "jspdf";

    import DeviceAppsActionCell from "@/components/kiosks/DeviceAppsActionCell.vue";
    import ConfirmAppAction from "@/components/kiosks/ConfirmAppAction.vue";
import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useDevicesStore } from "@/stores/devices";
import { useGridPreferencesStore } from "@/stores/gridPreferences";

    const dataGridRefName = ref(null);
    const allowedOperations = ref(["contains"]);
    // const buttonData = ref(["Excel", "CSV", "PDF"]);
    let apps = ref([]);
    const dataLoaded = ref(false);

    const emit = defineEmits(['refresh']);
    const uiStore = useUiStore();
    const devicesStore = useDevicesStore();
    const gridPreferencesStore = useGridPreferencesStore();
    let showClearAll = ref(false);

    let name = ref(null);
    const getModalAction = computed(()=> uiStore.modalAction);
    const getModalInfo = computed(()=> uiStore.modalData);
    const getModalState = computed(()=> uiStore.modalState);
    const companyId = useCompanyStore().companyId;
    const adminPreferenceId = ref(localStorage.getItem("adminPreferenceId"));
    const user = ref(JSON.parse(localStorage.getItem("userDetails")));
    const getDeviceDataObject = computed(()=> devicesStore.deviceDataObject);

    const dataGrid = computed(()=>{
        return dataGridRefName.value?.instance;
    });

    const showDeviceAppsModal = async () => {
      //      uiStore.setModalAction('device_apps');
      uiStore.setModalState(true);
      uiStore.setModalData(getDeviceDataObject.value);
    }

    const contentReady = (e) =>{
      
      let sortedExp = getSortedColumns();
      let filterExp = e.component.getCombinedFilter();
      if(filterExp || sortedExp) {
          showClearAll.value = true;
      }else{
          showClearAll.value = false;
      }
      setColumnChooserPosition();
      
    }

    const getSortedColumns = () =>{
        let allColumns = Array.from(Array(dataGrid.value.columnCount()).keys()).map(index => dataGrid.value.columnOption(index));
        allColumns = allColumns.find(col => col.sortIndex != null);
        return allColumns;
    }

    const customLoad = async () => {
      if(getModalAction.value == 'device_apps'){
        await gridPreferencesStore.onTableHeader({url: "/device-apps", companyId : companyId})
        .catch(() => {});
        let value = gridPreferencesStore.tableHeaders;
        return value;
      }
    }

    const customSave = (gridState) => {
      if(getModalAction.value == 'device_apps'){
        gridState.pageIndex = 0;
        gridState.pageSize = 10;
        let value = JSON.stringify(gridState);
        value = value.replace(',"selectedRowKeys":[]', "");

        if (!gridPreferencesStore.tableHeaders) {
        gridPreferencesStore.createTableHeaders({
            url: "/device-apps",
            headers: value,
            filters: "[]",
            companyId : companyId,
        }).catch(() => {});
        } else if (value != JSON.stringify(gridPreferencesStore.tableHeaders)) {
        gridPreferencesStore.updateTableHeaders({
            url: "/device-apps",
            headers: value,
            filters: "[]",
            companyId : companyId,
            adminPreferenceId : adminPreferenceId.value,

        }).catch(() => {});
        }
      }
    }

    const setColumnChooserPosition = () => {
        var columnChooserView = dataGrid.value.getView("columnChooserView");
        if (!columnChooserView._popupContainer) {
            columnChooserView._initializePopupContainer();
            columnChooserView.render();
        }
        columnChooserView._popupContainer.option("position", {
            of: dataGrid.value.element(),    
            my: "left top",
            at: "left top",
            offset: "0 50",
        });
    }

    const onEditorPreparing = (e) => {
        if (e.parentType == "filterRow") {
            e.editorOptions.placeholder = "Search";
        }
    }

    const clearFilter = () =>{
        dataGrid.value.clearFilter("row");
        dataGrid.value.clearFilter("header");
        dataGrid.value.clearFilter("search");
        dataGrid.value.clearSorting();
    }

    const onItemClick = (type) => {
        if (type == "Excel") {
          const workbook = new Workbook();
          const worksheet = workbook.addWorksheet("Main sheet");
          exportDataGrid({
              component: dataGrid.value,
              worksheet: worksheet,
              customizeCell: function (options) {
                  const excelCell = options;
                  excelCell.font = { name: "Arial", size: 12 };
                  excelCell.alignment = { horizontal: "left" };
              },
          }).then(function () {
              workbook.xlsx.writeBuffer().then(function (buffer) {
                  saveAs(
                  new Blob([buffer], { type: "application/octet-stream" }),
                  "device-apps.xlsx"
                  );
              });
          });
        // e.cancel = true;
        } else if (type == "CSV") {
          const workbook = new Workbook();
          const worksheet = workbook.addWorksheet("Main sheet");
          exportDataGrid({
          component: dataGrid.value,
              worksheet: worksheet,
              customizeCell: function (options) {
                  const excelCell = options;
                  excelCell.font = { name: "Arial", size: 12 };
                  excelCell.alignment = { horizontal: "left" };
              },
          }).then(function () {
              workbook.csv.writeBuffer().then(function (buffer) {
                  saveAs(
                  new Blob([buffer], { type: "application/octet-stream" }),
                  "device-apps.csv"
                  );
              });
          });
        } else if (type == "PDF") {
          const doc = new jsPDF("landscape");
          exportDataGridToPdf({
              jsPDFDocument: doc,
              component: dataGrid.value,
              customizeCell: function(options) {
                  const { gridCell, pdfCell } = options;
                  if(gridCell.rowType === 'data') {
                      // data columns style
                      pdfCell.styles = {
                      font: 'times',
                      fontStyle: 'lato',
                      fontSize: 8,
                      cellWidth: 'auto'
                      }
                  }else{
                      // header columns style
                      pdfCell.styles = {
                      font: 'times',
                      fontStyle: 'lato',
                      fontSize: 8,
                      fillColor : '#2680EB',
                      textColor : '#FFFFFF',
                      cellWidth: 'auto'
                      }
                  }
              }
          }).then(() => {
              const pageCount = doc.internal.getNumberOfPages();
              for(let i = 1; i <= pageCount; i++) {
                  doc.setPage(i);
                  const pageSize = doc.internal.pageSize;
                  const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
                  const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                  const header = 'Device Apps';
                  const headerWidth = doc.getTextDimensions(header).w;
                  const footer = `Page ${i} of ${pageCount}`;

                  // Header
                  doc.text(header, (pageWidth - headerWidth) / 2, 10);

                  // Footer
                  doc.text(footer, pageWidth / 2 - (doc.getTextWidth(footer) / 2), pageHeight - 5, { baseline: 'bottom' });
              }
              doc.save("device-apps.pdf");
          });
        }
    }
  const resetStoreData = () =>{
    uiStore.resetModalStore();
    emit('refresh');
  };

  onMounted (() => {
    if (getModalAction.value !== 'device_apps') return;
    setTimeout(() => {
      if (!dataLoaded.value) {
        dataGrid.value?.beginCustomLoading();
      }
    },300)
  })

  onBeforeMount(async ()=>{
    if(getModalInfo.value && getModalInfo.value.data_type == 'device' && getModalAction.value == 'device_apps'){

      devicesStore.setDeviceDataObject(getModalInfo.value);

      let data = {
        entityId: companyId,
        kioskName : getModalInfo.value.name,
        macAddress : getModalInfo.value.mac_address,
        userName : user.value.first_name+' '+ user.value.last_name,
        userId : user.value.user_id,
        connectionType : 'daemon',
      }
      devicesStore.fetchInstalledAppsGrid(data)
      .then((res) => {
        apps.value = JSON.parse(res.data);
      })
      .catch(() => {
      })
      .finally(() => {
        dataLoaded.value = true;
        dataGrid.value?.endCustomLoading();
      });

      name.value = getModalInfo.value.name;
    }
  });

</script>

<template>

  <ConfirmAppAction v-if="getModalState" @callDeviceApps="showDeviceAppsModal"/>

  <DModal v-if="getModalAction === 'device_apps'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="['modal-xl']" :dialog_classes="[]">
    <template #title> Apps ({{ name }}) </template>
  
    <template #body>

      <section class="grid-white-section">
  
        <DxDataGrid height="100%" :data-source="apps" 
        ref="dataGridRefName"
        :remote-operations="true"
        :showBorders="false"
        :columnAutoWidth="true"
        :allowColumnReordering="true"
        :allowColumnResizing="true"
        :rowAlternationEnabled="false"
        :showColumnLines="false"
        :showRowLines="true"
        :repaint-changes-only="true"
        :two-way-binding-enabled="true"
        :no-data-text="'No apps yet'"
        @editor-preparing="onEditorPreparing($event)"
        @content-ready="contentReady($event)"
        >

            <DxLoadPanel :show-indicator="true" :show-pane="true" :enabled="true"/>
            <DxScrolling mode="standard" :use-native="true" />
            <DxPaging :page-size="10" />
            <DxStateStoring :enabled="true" type="custom"  :customSave="customSave" :customLoad="customLoad"/>
    
            <DxPager
            :visible="true"
            :allowed-page-sizes="[10, 25, 50, 100]"
            :display-mode="'full'"
            :show-page-size-selector="true"
            :show-info="true"
            :show-navigation-buttons="true"
            />
    
            <!-- <DxFilterRow :visible="true" /> -->
            <DxSearchPanel :width="200" :visible="true" placeholder="Search ..."/>
            <DxSorting mode="single" />
            <DxHeaderFilter :visible="true" />
            <DxColumnChooser :enabled="true" mode="select" />

            <DxToolbar>
              <DxItem location="before" template="columnButtonTemplate" />
              <DxItem location="before" template="exportButtonTemplate" />
              <DxItem location="before" template="clearAllTemplate"/>
              <DxItem location="after" name="searchPanel" />
            </DxToolbar>
            
            <DxColumn data-field="icon" caption="Icon" :allow-header-filtering="false" cell-template="icon-cell"
            :allow-searching="true"  data-type="string"/>

            <DxColumn data-field="name" caption="Name" :allow-header-filtering="false"
            :allow-searching="true" :filter-operations="allowedOperations" data-type="string"/>

            <DxColumn data-field="packageId" caption="Package" :allow-header-filtering="false"
            :allow-searching="true" :filter-operations="allowedOperations" data-type="string"/>

            <DxColumn data-field="version" caption="Version" :allow-header-filtering="false"
            :allow-searching="true" :filter-operations="allowedOperations" data-type="string"/>

            <DxColumn caption="Actions" :allow-filtering="false" :allow-editing="false"
            :allow-reordering="false" cell-template="action-cell" css-class="select-actions select-actionsDAsh"
            />

            <template #icon-cell="{ data }">
              <div>
                <img class="app-icon-grid" :src="data.data.icon" crossorigin="anonymous"/>
              </div>
            </template>

            <template #action-cell="{ data }">
              <DeviceAppsActionCell :data="data.data"/>
            </template>

            <template #exportButtonTemplate>
              <button  @click="onItemClick('Excel')" type="button" class="btn action-btn m-5 font-20"><i class="bi bi-filetype-xlsx"></i> </button>
            </template>
    
            <template #columnButtonTemplate>
              <button  @click="dataGrid.showColumnChooser()" type="button" class="btn action-btn font-20 m-5"><i class="bi bi-columns"></i> </button>
            </template>
    
            <template #clearAllTemplate>
              <div v-if="showClearAll" class="clear-cols">
                <div class="custom-line"></div>
                <button @click="clearFilter()" type="button" class="btn action-btn clear-colums-filter m-5">Clear Filters </button>
              </div>
            </template>
        </DxDataGrid>
      </section>
    </template>
  </DModal>
</template>